import React, { useState } from 'react';

export default function StarRating({ value, onChange }) {
  const [hovered, setHovered] = useState(0);

  return (
    <div
      className="flex gap-1"
      role="radiogroup"
      aria-label="Star rating"
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          role="radio"
          aria-checked={value === star}
          aria-label={`${star} star${star !== 1 ? 's' : ''}`}
          onClick={() => onChange(star)}
          onMouseEnter={() => setHovered(star)}
          onMouseLeave={() => setHovered(0)}
          className={`text-4xl leading-none transition-all duration-100 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 rounded ${
            star <= (hovered || value)
              ? 'text-yellow-400 drop-shadow-sm'
              : 'text-gray-200'
          }`}
        >
          ★
        </button>
      ))}
    </div>
  );
}
